import { render } from "./BinModal.vue?vue&type=template&id=13f92d89&scoped=true&ts=true"
import script from "./BinModal.vue?vue&type=script&lang=ts"
export * from "./BinModal.vue?vue&type=script&lang=ts"

import "./BinModal.vue?vue&type=style&index=0&id=13f92d89&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f92d89"]])

export default __exports__